<template>
  <div class="app-container" v-loading="storeLoading">
    <!-- v-if="secondList.length==form.product_category.length" -->
    <el-form
        ref="form"
        :model="form"
        label-position="right"
        label-width="70px"
        style="width: 800px; margin-left:50px;"
        v-if="!storeLoading"
    >
      <!--  -->
      <el-form-item label="标题" prop="title" label-width="130px">
        <el-input v-model="form.title" placeholder="请输入标题"/>
      </el-form-item>
      <el-form-item label="封面(316x115)" prop="cover" label-width="130px">
        <uploadOne v-model="form.cover" width="120px" height="120px"></uploadOne>
      </el-form-item>
      <el-form-item label="轮播图(750X320)" prop="images" label-width="130px">
        <uploadList v-model="form.images" width="120px" height="120px"></uploadList>
      </el-form-item>
      <el-form-item label="类型" prop="type" label-width="130px">
        <el-select v-model="form.type" @change="clearForm" :disabled="this.form.id?true:false">
          <el-option label="套餐" :value="1"></el-option>
          <el-option label="路线" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
          label="分类"
          prop="product_category"
          label-width="130px"
          :inline="true"
          style="width: 1080px;"
          v-if="showCategory"
      >
        <div v-for="(item,index) in form.product_category" :key="index">
          <el-row style="margin-bottom:5px">
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <el-select
                    placeholder="国内酒店"
                    v-model="item.parent_parent_id"
                    :clearable="true"
                    @change="clearId(index,1)"
                >
                  <el-option
                      v-for="item in firstList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <el-select
                    placeholder="二级类目"
                    v-if="item.parent_parent_id"
                    :clearable="true"
                    v-model="item.parent_id"
                    @visible-change="getCategory($event,1,index,2)"
                    :loading="loading"
                >
                  <el-option
                      v-for="item in secondList[index]"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <el-select
                    placeholder="三级类目"
                    v-if="item.parent_parent_id&&item.parent_id"
                    :clearable="true"
                    v-model="item.id"
                    :loading="loading"
                    @visible-change="getCategory($event,1,index,3)"
                >
                  <el-option
                      v-for="item in thirdList[index]"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="6">
              <el-button
                  type="primary"
                  @click="addClub"
                  v-if="item.id&&index == form.product_category.length-1"
              >添加分类
              </el-button>
              <el-button type="danger" @click="delClub(index)" v-if="index > 0">删除分类</el-button>
            </el-col>
          </el-row>
        </div>
      </el-form-item>
      <el-form-item
          label="目的地"
          prop="destination"
          label-width="130px"
          :inline="true"
          style="width: 1080px;"
      >
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select
                placeholder="一级目的地"
                :clearable="true"
                v-model="form.first_destination"
                @change="clearId(0,2)"
            >
              <el-option
                  v-for="item in firstDestinationList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select
                placeholder="二级目的地"
                :clearable="true"
                v-if="this.form.first_destination"
                v-model="form.second_destination"
                :loading="loading"
                @visible-change="getCategory($event,2,0,2)"
            >
              <el-option
                  v-for="item in secondDestinationList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select
                placeholder="三级目的地"
                :clearable="true"
                :loading="loading"
                v-if="this.form.first_destination&&this.form.second_destination"
                v-model="form.third_destination"
                @visible-change="getCategory($event,2,0,3)"
            >
              <el-option
                  v-for="item in thirdDestinationList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </el-col>
      </el-form-item>
      <el-form-item label="预定方式" prop="reserve" label-width="130px" v-if="form.type==1">
        <el-select placeholder v-model="form.reserve">
          <el-option label="先付款再预定" :value="1"></el-option>
          <el-option label="先预定再付款" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="套餐有效期" prop="stock" label-width="130px">
        <el-date-picker
            v-model="form.expired"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="库存" prop="stock" label-width="130px">
        <el-input v-model="form.stock" @input="form.stock=form.stock.replace(/^\.+|[^\d]/g,'')"/>
      </el-form-item>
      <el-form-item label="币种" prop="currency_type" label-width="130px">
        <el-radio-group v-model="form.currency_type">
          <el-radio :label="1" border>人民币</el-radio>
          <el-radio :label="2" border>澳币</el-radio>
        </el-radio-group>
      </el-form-item>
      <div v-if="form.type==1">
        <!-- <el-form-item label="房型" prop="stock" label-width="130px"> -->
        <el-form-item label="产品类型" prop="stock" label-width="130px">
          <el-row>
            <div
                class="grid-content bg-purple"
                style="font-size:80px; "
                v-if="form.product_house.length==0"
            >
              <el-button type="primary" @click="addProductHouse">添加房型</el-button>
            </div>
          </el-row>
          <div v-for="(item,index) in form.product_house" :key="index">
            <div
                style="border-width: 0 0 1px 0;
border-style: solid;
border-color: #DCDFE6;margin-bottom:10px"
                v-if="item"
            >
              <el-row>
                <el-col :span="8">
                  <!-- <el-form-item label="房型名称" prop="price" style="margin-bottom:10px"> -->
                  <el-form-item label="类型信息" prop="price" style="margin-bottom:10px">
                    <el-input
                        v-model="item.house_name"
                        placeholder="房型名称"
                        maxlength="10"
                        style="width:150px"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <div class="grid-content bg-purple">
                    <el-form-item label="团长送双倍积分，积分1：" prop label-width="190px">1</el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8" v-if="form.type==1">
                  <div class="grid-content bg-purple">
                    <el-form-item label="参考价格" prop="price">
                      <el-input v-model="item.price" placeholder/>
                    </el-form-item>
                  </div>
                </el-col>

                <el-col :span="8">
                  <div class="grid-content bg-purple">
                    <el-form-item label="会员价" prop="vip_price">
                      <el-input
                          v-model="item.vip_price"
                          placeholder="无则不填"
                          @input="recordCostHousePrice('vip_price',0)"
                      />
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="8">
                  <el-button
                      type="primary"
                      @click="addProductHouse"
                      style="margin-left:10px"
                      v-if="index == form.product_house.length-1"
                  >添加房型
                  </el-button>
                </el-col>
              </el-row>
              <el-row style="margin-top:10px;margin-bottom:10px">
                <el-col :span="8">
                  <div class="grid-content bg-purple">
                    <el-form-item label="拼团价" prop="group_price">
                      <el-input
                          v-model="item.group_price"
                          placeholder="无则不填"
                          @input="recordCostHousePrice('group_price',0)"
                      />
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="grid-content bg-purple">
                    <el-form-item label="成团人数" prop="group_num" label-width="100px">
                      <el-input
                          v-model="item.group_num"
                          placeholder="无则不填"
                          @input="form.product_house[index].group_num=form.product_house[index].group_num.replace(/^\.+|[^\d]/g,'')"
                      />
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="8">
                  <el-button
                      type="danger"
                      @click="delProductHouse(index)"
                      style="margin-left:10px"
                  >删除房型
                  </el-button>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form-item>
      </div>
      <div v-if="form.type==2">
        <el-row>
          <el-col :span="12" v-if="form.type==1">
            <div class="grid-content bg-purple">
              <el-form-item label="参考价格" prop="price" label-width="130px">
                <el-input v-model="form.price" placeholder @input="recordCostPrice('price')"/>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12" v-if="form.type==2">
            <div class="grid-content bg-purple">
              <el-form-item label="成人价" prop="price" label-width="130px">
                <el-input v-model="form.price" placeholder @input="recordCostPrice('price')"/>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="12">
            <div class="grid-content bg-purple">
              <el-form-item label="会员价" prop="vip_price" label-width="130px">
                <el-input
                    v-model="form.vip_price"
                    placeholder="无则不填"
                    @input="recordCostPrice('vip_price')"
                />
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-form-item label="儿童价(仅用于参考)" v-if="form.type==2" prop="kid_price" label-width="130px">
          <el-input v-model="form.kid_price" placeholder @input="recordCostPrice('kid_price')"/>
        </el-form-item>
        <el-row>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="拼团价" prop="group_price" label-width="130px">
                <el-input
                    v-model="form.group_price"
                    placeholder="无则不填"
                    @input="recordCostPrice('group_price')"
                />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="成团人数" prop="group_num" label-width="100px">
                <el-input
                    v-model="form.group_num"
                    placeholder="无则不填"
                    @input="recordNum('group_num')"
                />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="团长送双倍积分，积分1：" prop label-width="190px">1</el-form-item>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- <el-form-item label="私人定制" prop="novel" label-width="130px"> -->
      <el-form-item label="客服按钮" prop="novel" label-width="130px">
        <el-input type="textarea" :rows="2" v-model="form.personal_tailor" placeholder="无则不填"/>
      </el-form-item>
      <!-- <el-form-item label="特惠小说明" prop="novel" label-width="130px">
        <el-input v-model="form.novel" placeholder="如：特惠只要￥99" /> -->
      <el-form-item label="标签文字" prop="novel" label-width="130px">
        <el-input v-model="form.novel" placeholder="自营或其他标签信息，无则不填"/>
      </el-form-item>
      <el-form-item label="费用包含" prop label-width="130px" v-if="form.type==1">
        <div v-for="(item,index) in includeForm" :key="'inc' + index">
          <!-- <el-input
            type="textarea"
            :rows="2"
            v-model="form.price_include"
            placeholder="例子：XXXXXX#XXXXXX"
          /> -->
          <el-row>
            <el-col :span="19">
              <el-input
                  style="margin:5px"
                  type="textarea"
                  :rows="3"
                  v-model="item.priceInc"
              />
            </el-col>
            <el-col :span="5">
              <el-button type="primary" @click="addPriceInclude" v-if="index == includeForm.length-1"
                         style="margin: 0 0 5px 15px">添加费用包含
              </el-button>
              <el-button type="danger" @click="delPriceInclude(index)" v-if="includeForm.length != 1"
                         style="margin-left:15px">删除费用包含
              </el-button>
            </el-col>
          </el-row>
        </div>
        <el-form-item label="住宿套餐" prop label-width="70px"></el-form-item>
        <el-form-item label="套餐标题" prop="package_name" label-width="70px">
          <el-input v-model="form.package_name" placeholder/>
        </el-form-item>
        <el-row v-if="form.product_package.length>0">
          <el-col :span="18">
            <div
                class="grid-content bg-purple"
                style="border:1px solid #DCDFE6;height:auto;margin-top:10px;"
            >
              <el-form-item label="项目标题" prop="title" label-width="100px" style="margin-top: 10px;">
                <el-col :span="13">
                  <el-input v-model="form.product_package[0].title" placeholder/>
                </el-col>
              </el-form-item>
              <!-- <el-form-item
                label="住宿时长"
                prop="live_time"
                label-width="100px"
                style="margin-top: 10px;"
              >
                <el-col :span="3">
                  <el-input
                    v-model="form.product_package[0].live_time"
                    placeholder
                    @input="recordNum('live_time')"
                  />
                </el-col>
                <el-col class="line" :span="3">晚</el-col>
              </el-form-item> -->
              <el-form-item
                  label="使用场所"
                  prop="shop_id"
                  label-width="100px"
                  style="margin-top: 10px;"
              >
                <el-col :span="13">
                  <el-select placeholder v-model="form.product_package[0].shop_id">
                    <el-option
                        v-for="item in shopList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col
                    :span="8"
                    style="color:red;text-align:center"
                    v-if="!form.product_package[0].shop_id"
                >须先添加供应商
                </el-col>
              </el-form-item>
              <el-form-item
                  label="说明"
                  prop="introduce"
                  label-width="100px"
                  style="margin-top: 10px;margin-bottom:10px"
              >
                <el-col :span="13">
                  <el-input type="textarea" :rows="3" v-model="form.product_package[0].introduce"/>
                </el-col>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-form-item label="其他项目" prop label-width="70px"></el-form-item>
        <div v-for="(item,index) in form.product_package" :key="index">
          <el-row v-if="index " style="margin-bottom:5px">
            <el-col :span="18">
              <div class="grid-content bg-purple" style="border:1px solid #DCDFE6;height:200px;">
                <el-form-item label="标题" prop="title" label-width="100px" style="margin-top: 10px;">
                  <el-col :span="13">
                    <el-input v-model="item.title" placeholder/>
                  </el-col>
                </el-form-item>
                <el-form-item
                    label="使用场所"
                    prop="description"
                    label-width="100px"
                    style="margin-top: 10px;"
                >
                  <el-col :span="13">
                    <el-select placeholder v-model="item.shop_id">
                      <el-option
                          v-for="item in shopList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" style="color:red;text-align:center" v-if="!item.shop_id">须先添加供应商</el-col>
                </el-form-item>
                <el-form-item
                    label="说明"
                    prop="introduce"
                    label-width="100px"
                    style="margin-top: 10px;"
                >
                  <el-col :span="13">
                    <el-input type="textarea" :rows="3" v-model="item.introduce"/>
                  </el-col>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple" style="font-size:80px; text-align: center;">
                <el-col :span="24">
                  <el-button
                      type="primary"
                      v-if="index == form.product_package.length-1"
                      @click="addPackage"
                  >添加项目
                  </el-button>
                </el-col>
                <el-button type="danger" @click="delPackage(index)">删除项目</el-button>
              </div>
            </el-col>
          </el-row>
          <el-row v-if="form.product_package.length==1 ">
            <div class="grid-content bg-purple" style="font-size:80px; ">
              <el-button type="primary" @click="addPackage">添加项目</el-button>
            </div>
          </el-row>
        </div>
      </el-form-item>
      <el-form-item label="费用包含" prop="price_include" label-width="130px" v-if="form.type==2">
        <el-input type="textarea" :rows="3" v-model="form.price_include" style="margin-bottom:20px"/>
      </el-form-item>
      <el-form-item label="费用不含" prop="price_not_include" label-width="130px" v-if="form.type==2">
        <el-input type="textarea" :rows="2" v-model="form.price_not_include"/>
      </el-form-item>
      <el-form-item label="打包推荐" prop="product_recommend" label-width="130px">
        <el-row>
          <div
              class="grid-content bg-purple"
              style="font-size:80px; "
              v-if="form.product_recommend.length==0"
          >
            <el-button type="primary" @click="addRecommend">添加推荐</el-button>
          </div>
        </el-row>
        <div v-for="(item,index) in form.product_recommend" :key="index">
          <el-row style="margin-bottom:5px">
            <el-col :span="18">
              <div class="grid-content bg-purple" style="border:1px solid #DCDFE6;height:250px;">
                <el-row>
                  <el-col :span="11">
                    <div class="grid-content bg-purple">
                      <el-form-item
                          label="价格"
                          prop="price"
                          label-width="50px"
                          style="margin-top: 10px;"
                      >
                        <el-input
                            v-model="item.price"
                            placeholder
                            @input="recordArrPrice(index,'price')"
                        />
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="11">
                    <div class="grid-content bg-purple">
                      <el-form-item
                          label="原价"
                          prop="origin_price"
                          label-width="50px"
                          style="margin-top: 10px;"
                      >
                        <el-input
                            v-model="item.origin_price"
                            placeholder
                            @input="recordArrPrice(index,'origin_price')"
                        />
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="11">
                    <el-form-item
                        label="标题"
                        prop="title"
                        label-width="50px"
                        style="margin-top: 10px;"
                    >
                      <el-input v-model="item.title" placeholder/>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="11">
                    <el-form-item
                        label="使用场所"
                        prop="description"
                        label-width="80px"
                        style="margin-top: 10px;"
                        v-if="form.type==1"
                    >
                      <el-col :span="13">
                        <el-select placeholder v-model="item.shop_id" style="width:150px">
                          <el-option
                              v-for="item in shopList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-col>
                    </el-form-item>
                  </el-col>
                  <el-col
                      :span="8"
                      style="color:red;text-align:center"
                      v-if="form.type==1&&!item.shop_id"
                  >须先添加供应商
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="11">
                    <el-form-item
                        label="说明"
                        prop="introduce"
                        label-width="50px"
                        style="margin-top: 10px;"
                    >
                      <el-input type="textarea" :rows="3" v-model="item.introduce"/>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple" style="font-size:80px; text-align: center;">
                <el-col :span="24">
                  <el-button
                      type="primary"
                      v-if="index == form.product_recommend.length-1"
                      @click="addRecommend"
                  >添加推荐
                  </el-button>
                </el-col>
                <el-button type="danger" @click="delRecommend(index)">删除推荐</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-form-item>
      <el-form-item label="产品详情" prop="description" label-width="130px">
        <tinymce :height="400" v-model="form.description" ref="content"/>
      </el-form-item>
      <el-form-item label="购买须知" prop label-width="130px">
        <el-form-item label="使用说明" prop="instructions" label-width="70px">
          <!-- <el-input type="textarea" :rows="7" v-model="form.instructions" /> -->
          <tinymce :height="400" v-model="form.instructions" :showMedia="false" ref="instructions"/>
        </el-form-item>
        <el-form-item
            label="退改说明"
            prop="return_modify"
            label-width="70px"
            style="margin-top: 10px;"
        >
          <!-- <el-input type="textarea" :rows="7" v-model="form.return_modify" /> -->
          <tinymce :height="400" v-model="form.return_modify" :showMedia="false" ref="return_modify"/>
        </el-form-item>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-if="!this.form.id" @click="reset">清除</el-button>
      <el-button @click="goBack" style="margin-right: 20px;">返回</el-button>
      <el-button type="primary" v-if="!this.form.id" @click="saveCacheData">保存</el-button>
      <el-button type="primary" @click="saveData" :loading="btnLoading">提交</el-button>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import uploadList from "@/components/UploadList";
import uploadOne from "@/components/UploadOne";
import Tinymce from "@/components/Tinymce";
import log from "echarts/src/scale/Log";

export default {
  components: {Tinymce, uploadOne, uploadList},
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger"
      };
      return statusMap[status];
    }
  },
  data() {
    return {
      storeLoading: false,
      loading: false,
      showCategory: false,
      listLoading: true,
      btnLoading: false,
      position: "",
      firstList: [],
      secondList: [],
      thirdList: [],
      firstDestinationList: [],
      secondDestinationList: [],
      thirdDestinationList: [],
      shopList: [],
      lastRouteQuery: null,
      isFormInitialized: false,
      form: {
        id: null,
        shop_id: 0,
        title: "",
        cover: "",
        images: [],
        price: "",
        vip_price: "",
        kid_price: "",
        reserve: "",
        group_price: "",
        group_num: "",
        first_destination: "",
        second_destination: "",
        third_destination: "",
        sell: "0",
        personal_tailor: "",
        novel: "",
        price_include: "",
        price_not_include: "",
        stock: "",
        package_name: "",
        description: "",
        instructions: "",
        return_modify: "",
        type: 1,
        inspect_status: "1",
        status: "1",
        special_offer: "1",
        new_product: "1",
        weight: "1",
        expired: "",
        product_house: [],
        product_category: [
          {
            id: null,
            parent_id: null,
            parent_parent_id: null,

            pivot: {
              product_id: null,
              product_category_id: null
            }
          }
        ],
        product_package: [
          {
            id: null,
            product_id: null,
            shop_id: null,
            title: "",
            live_time: 1,
            introduce: ""
          }
        ],
        product_recommend: [
          // {
          // id: "",
          // product_id: "",
          // title: "",
          // price: "",
          // origin_price: "",
          // shop_id: "",
          // introduce: ""
          // }
        ],
        currency_type: 1,
      },
      id: null,
      limit: true,
      provinces: [],
      cities: [],
      positionNum: "",
      selectIdx: null,
      showMap: false,
      timer: '',
      includeForm: [
        {
          priceInc: ''
        }
      ]
    };
  },
  created() {
    var cached = localStorage.getItem("lastRouteQueryId");
    var lastRouteQueryId = (this.$route.query.id || 0);
    console.log(cached, lastRouteQueryId, Number(cached) === Number(lastRouteQueryId));
    if (cached && Number(cached) === Number(lastRouteQueryId)) {
      var lastFrom = localStorage.getItem("lastFrom");
      this.getShopList();
      this.getFatherCategoryList(1, 0, 1, false);
      this.getFatherCategoryList(2, 0, 1, false);
      this.form = JSON.parse(lastFrom);
      console.log(this.form)

      if (this.form.first_destination) {
        this.getFatherCategoryList(2, 0, 2, false, false);

        if (this.form.second_destination) {
          this.getFatherCategoryList(2, 0, 3, false, true);
        }
      }

      this.form.product_category.forEach((element, index) => {
        console.log('element'+JSON.stringify(element))

        if(element.parent_parent_id){
          this.getFatherCategoryList(1, index, 2, false, true);
        }

        if(element.parent_id){
          this.getFatherCategoryList(1, index, 3, false, true);
        }
        // this.secondList[index] = [element.parent];
        // this.thirdList[index] = [element];
      });

      // if (this.form.id) {
      //   if (this.form.type == 1) {
      //     let arr = this.form.price_include.split('#')
      //     this.includeForm = []
      //     arr.forEach(val => {
      //       let obj = {}
      //       obj.priceInc = val
      //       this.includeForm.push(obj)
      //     })
      //   }
      // }

      this.isFormInitialized = true;
      this.showCategory = true;
    } else {
      localStorage.setItem("lastRouteQueryId", lastRouteQueryId);
      this.fetchData();
    }
  },
  destroyed() {

  },
  watch: {
    form: {
      handler(newVal) {
        if (this.isFormInitialized) {
          console.log("form 变化了:", "→", newVal);
          localStorage.setItem("lastFrom", JSON.stringify(newVal || {}));
        }
      },
      deep: true

    }
  },
  methods: {
    fetchData(route = this.$route) {
      this.id = route.query.id;

      this.getShopList();
      this.getFatherCategoryList(1, 0, 1);
      this.getFatherCategoryList(2, 0, 1);

      if (this.id) {
        this.storeLoading = true;
        this.getData();
      } else {
        // 默认表单数据
        this.form.personal_tailor = "如需帮助，点击联系客服";
        this.form.instructions = `<ul><li>入住有效期：<span style="color: #ed6464;"><strong>即日起至2020.12.30（10.1-10.6不适用）</strong></span>；</li><li>此套餐产品每日限量预约，需至少提前5天预约，预约情况须以酒店入住率为准；</li><li>所有订购均需<span style="color: #ed6464;"><strong>二次确认</strong></span>，预定完成后，我方平台会在18个工作小时内（工作日9:00-18:00）确认是否预定成功，最终以短信或客服通知为准。如预约失败，建议更改出行日期或者申请退款，详情参考退改说明。</li><li>本产品无需出团确认书，预定成功后即可出行。</li><li>酒店入住时间：下午15:00后，</li></ul><p style="padding-left: 30px;">&nbsp; 离店时间：中午12:00前；</p><ul><li>酒店入住方式：预订人持有效身份证件及酒店确认单号，于酒店前台办理入住。</li></ul><p>&nbsp;</p><p><strong>【费用说明】</strong></p><ul><li>产品价格已包含税费；</li><li>费用包含套餐内容中所列的成人及儿童限数；超出部分需另付费，具体可咨询客服；</li><li>加床政策及具体金额，可咨询客服；</li><li>产品中的部分餐食、活动项目，需提前与酒店预约，具体政策，可与客服咨询。</li></ul><p>&nbsp;</p><p>&nbsp;</p><p><strong>【开票说明】</strong></p><p style="padding-left: 30px;">我方平台为订单开具增值税电子普通发票，预定人需于入住完成后的三个月内申请，逾期恕不办理。</p>`;
        this.form.return_modify = `<ul><li>订单付款成功后，未预约的套餐可以免费退；已预约成功的套餐，恕不接受任何退订及更改。</li><li>如因自身证件或身体健康状况等个人原因，导致订单无法出行或产生损失，责任自负。</li></ul><p>&nbsp;</p><p><strong>【如果申请退款】</strong></p><ul><li>未预约日期，我的&gt;全部订单&gt;申请售后&gt;申请退款；</li><li>已经预约日期/或者二次确认失败，请联系客服，或者添加客服微信进行处理。</li><li>客服微信号：dxwl_emma</li></ul>`;
        this.showCacheData();
        this.isFormInitialized = true;
      }

      this.showCategory = true;
    },
    addPriceInclude() {
      let obj = {
        priceInc: ''
      }
      this.includeForm.push(obj)
    },
    delPriceInclude(idx) {
      this.includeForm.splice(idx, 1);
    },
    clearId(index, type) {
      if (type == 1) {
        this.form.product_category[index].parent_id = null;
        this.form.product_category[index].id = null;
        this.form.product_category[index].name = "";
      } else {
        this.form.second_destination = "";
        this.form.third_destination = "";
      }
    },
    getCategory(flag, type, index, level) {
      // this.secondList[index] = null
      // this.thirdList[index] = null
      this.loading = true;
      if (flag) {
        this.getFatherCategoryList(type, index, level);
      }
    },
    getShopList() {
      request({
        url: "/api/backend/shop",
        method: "get",
        params: ""
      }).then(response => {
        this.shopList = response.data.data;
      });
    },
    getData() {
      this.listLoading = true;
      request({
        url: "/api/backend/product/detail",
        method: "get",
        params: {
          id: this.id
        }
      }).then(response => {
        this.form = response.data;
        this.secondDestinationList.push(this.form.second_destination);
        this.thirdDestinationList.push(this.form.third_destination);
        this.form.first_destination = this.form.first_destination.id;
        this.form.second_destination = this.form.second_destination.id;
        this.form.third_destination = this.form.third_destination.id;
        this.form.product_category.forEach((element, index) => {
          this.secondList[index] = [element.parent];
          this.thirdList[index] = [element];
        });
        if (this.form.type == 1) {
          let arr = this.form.price_include.split('#')
          this.includeForm = []
          arr.forEach(val => {
            let obj = {}
            obj.priceInc = val
            this.includeForm.push(obj)
          })
        }

        // console.log(arr)
        // console.log(this.includeForm)
        // if (this.form.product_house.length == 1) {
        //   if (this.form.product_house[0].house_type == 1) {
        //     this.form.product_house.push(null);
        //   } else {
        //     this.form.product_house.unshift(null);
        //   }
        // }
        // this.form.product_house.forEach((element,index) => {
        //   if (element) {
        //     if (element.house_type == 1) {
        //       this.checkList.push("大床");
        //       this.showHousePrice[0] = true;
        //       this.house_names[index]=element.house_name;
        //     } else {
        //       this.checkList.push("双床");
        //       this.showHousePrice[1] = true;
        //       this.house_names[index]=element.house_name;
        //     }
        //   }
        // });
        localStorage.setItem("lastFrom", JSON.stringify(this.form || {}));
        this.isFormInitialized = true;
        this.storeLoading = false;
        this.showCategory = true;
        this.listLoading = false;
      });
    },
    // getProvince() {
    //   return request({
    //     url: "/api/common/area/index",
    //     method: "get"
    //   }).then(res => {
    //     this.provinces = res.data;
    //   });
    // },

    addClub() {
      let obj = {
        id: null,
        parent_id: null,
        parent_parent_id: null,

        pivot: {
          product_id: null,
          product_category_id: null
        }
      };
      this.form.product_category.push(obj);
    },
    delClub(idx) {
      this.form.product_category.splice(idx, 1);
      this.secondList.splice(idx, 1);
      this.thirdList.splice(idx, 1);
    },
    recordCostPrice(e) {
      if (e == "price") {
        this.form.price = this.form.price.match(/^\d*(\.?\d{0,2})/g)[0] || null;
      } else if (e == "vip_price") {
        this.form.vip_price =
            this.form.vip_price.match(/^\d*(\.?\d{0,2})/g)[0] || null;
      } else if (e == "kid_price") {
        this.form.kid_price =
            this.form.kid_price.match(/^\d*(\.?\d{0,2})/g)[0] || null;
      } else if (e == "group_price") {
        this.form.group_price =
            this.form.group_price.match(/^\d*(\.?\d{0,2})/g)[0] || null;
      }
    },
    recordCostHousePrice(e, index) {
      if (e == "price") {
        this.form.product_house[index].price =
            this.form.product_house[index].price.match(/^\d*(\.?\d{0,2})/g)[0] ||
            null;
      } else if (e == "vip_price") {
        this.form.product_house[index].vip_price =
            this.form.product_house[index].vip_price.match(
                /^\d*(\.?\d{0,2})/g
            )[0] || null;
      } else if (e == "kid_price") {
        this.form.kid_price =
            this.form.kid_price.match(/^\d*(\.?\d{0,2})/g)[0] || null;
      } else if (e == "group_price") {
        this.form.product_house[index].group_price =
            this.form.product_house[index].group_price.match(
                /^\d*(\.?\d{0,2})/g
            )[0] || null;
      }
    },
    recordArrPrice(e, type) {
      if (type == "price") {
        this.form.product_recommend[e].price =
            this.form.product_recommend[e].price.match(/^\d*(\.?\d{0,2})/g)[0] ||
            null;
      } else if (type == "origin_price") {
        this.form.product_recommend[e].origin_price =
            this.form.product_recommend[e].origin_price.match(
                /^\d*(\.?\d{0,2})/g
            )[0] || null;
      }
    },
    recordNum(e) {
      if (e == "live_time") {
        this.form.product_package[0].live_time =
            this.form.product_package[0].live_time.match(/^[1-9]\d*/g)[0] || null;
      } else if (e == "group_num") {
        this.form.group_num =
            this.form.group_num.match(/^[1-9]\d*/g)[0] || null;
      } else if (e == "stock") {
        // console.log(this.form.stock.match(/^[1-9]\d*/g)[0]);
        this.form.stock = this.form.stock.match(/^[1-9]\d*/g)[0] || null;
      }
    },
    recordHouseNum(e, index) {
      if (e == "group_num") {
        this.form.product_house[index].group_num =
            this.form.product_house[index].group_num.match(/\D/g)[0] || null;
      }
    },
    clearForm() {
      // this.resetForm(this.form.type, this.form.id);
      if (this.form.type == 1) {
        this.form.reserve = "";
        this.form.price_not_include = "";
        this.form.product_package = [
          {
            id: null,
            product_id: null,
            shop_id: null,
            title: "",
            live_time: "1",
            introduce: ""
          }
        ];
        this.form.product_recommend.forEach((element, index) => {
          this.form.product_recommend[index].shop_id = "";
        });
        this.includeForm = [
          {
            priceInc: ''
          }
        ]
      } else {
        this.form.product_recommend.forEach((element, index) => {
          this.form.product_recommend[index].shop_id = 0;
        });
      }
      this.form.kid_price = "";
      this.form.package_name = "";
      this.form.price_include = "";

      // this.$refs.content.setContent("");
      // this.form = {
      //   id:  this.form.id,
      //   shop_id:this.form.shop_id,
      //   title: this.form.title,
      //   cover: this.form.cover,
      //   images: this.form.images,
      //   price: "",
      //   vip_price: "",
      //   kid_price: "",
      //   reserve: "",
      //   group_price: "",
      //   group_num: "",
      //   first_destination: "",
      //   second_destination: "",
      //   third_destination: "",
      //   sell: "0",
      //   novel: "",
      //   price_include: "",
      //   price_not_include: "",
      //   stock: "",
      //   package_name: "",
      //   description: "",
      //   instructions: "",
      //   return_modify: "",
      //   type: this.form.type,
      //   inspect_status: "1",
      //   status: "1",
      //   special_offer: "1",
      //   new_product: "1",
      //   weight: "1",
      //   expired: "2020-12-12",
      //   product_category: [
      //     {
      //       id: "",
      //       parent_id: "",
      //       parent_parent_id: "",

      //       pivot: {
      //         product_id: "",
      //         product_category_id: ""
      //       }
      //     }
      //   ],
      //   product_package: [
      //     {
      //       id: "",
      //       product_id: "",
      //       shop_id: "",
      //       title: "",
      //       live_time: "",
      //       introduce: ""
      //     }
      //   ],
      //   product_recommend: [
      //     // {
      //     //   id: "",
      //     //   product_id: "",
      //     //   title: "",
      //     //   price: "",
      //     //   origin_price: "",
      //     //   shop_id: "",
      //     //   introduce: ""
      //     // }
      //   ]
      // }
    },
    // 提交
    handler() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.limit) {
            this.form.number_limitation = 0;
          }
          this.btnLoading = true;
          request({
            url: "/api/backend/match",
            method: "post",
            data: this.form
          })
              .then(response => {
                this.btnLoading = false;
                this.$notify({
                  title: "成功",
                  message: "保存成功",
                  type: "success",
                  duration: 2000
                });
                this.$router.push("/information/list");
              })
              .catch(err => {
                this.btnLoading = false;
              });
        } else {
          return false;
        }
      });
    },
    saveData() {
      if (this.form.type == 1) {
        this.form.shop_id = this.form.product_package[0].shop_id;
        this.form.kid_price ? this.form.kid_price : (this.form.kid_price = 15);
      } else {
        this.form.shop_id = 0;
        this.form.reserve = 1;
        this.form.package_name = "成人价";
        this.form.product_package = [];
      }
      if (this.form.type == 1) {
        this.form.price_include = ''
        this.includeForm.forEach(val => {
          this.form.price_include += '#' + val.priceInc
        })
        this.form.price_include = this.form.price_include.substr(1)
      }
      // console.log(this.form.price_include)
      // console.log(this.includeForm)


      // console.log(this.form);
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/product",
            method: "post",
            data: this.form
          })
              .then(response => {
                this.btnLoading = false;
                this.dialogFormVisible = false;
                localStorage.removeItem("lastRouteQueryId");
                localStorage.removeItem("lastFrom");
                this.clearForm()
                this.$notify({
                  title: "成功",
                  message: "保存成功",
                  type: "success",
                  duration: 2000
                });
                if (this.form.id) {
                  this.goBack()
                } else {
                  clearTimeout(this.timer);  //清除延迟执行
                  this.timer = setTimeout(() => {   //设置延迟执行
                    console.log('ok');
                  }, 2000);
                }
              })
              .catch(err => {
                this.btnLoading = false;
              });
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    getProvinceList() {
      request({
        url: "/api/common/area/index",
        method: "get",
        params: ""
      }).then(response => {
        this.provinceList = response.data;
      });
    },
    getCityList(type) {
      if (type == 1) {
        this.form.city_id = null;
        this.form.district_id = null;
      }
      request({
        url: "/api/common/area/cities",
        method: "get",
        params: {province_id: this.form.province_id}
      }).then(response => {
        this.cityList = response.data;
      });
    },
    getDistrictsList() {
      request({
        url: "/api/common/area/districts",
        method: "get",
        params: {city_id: this.form.city_id}
      }).then(response => {
        this.districtList = response.data;
      });
    },
    addPackage() {
      let obj = {
        id: null,
        product_id: null,
        shop_id: null,
        title: "",
        live_time: "0",
        introduce: ""
      };
      this.form.product_package.push(obj);
    },
    delPackage(idx) {
      this.form.product_package.splice(idx, 1);
    },
    handleCheckedChange(value, type) {
      if (value) {
        let obj = {
          id: null,
          house_name: "",
          house_type: type,
          price: "",
          vip_price: "",
          group_price: "",
          group_num: ""
        };
        if (type == 1) {
          this.$set(this.form.product_house, "0", obj);
          this.showHousePrice[0] = true;
        } else {
          this.$set(this.form.product_house, "1", obj);
          this.showHousePrice[1] = true;
        }
      } else {
        if (type == 1) {
          this.form.product_house[0] = null;
          this.house_names[0] = "大床房";
          this.showHousePrice[0] = false;
        } else {
          this.form.product_house[1] = null;
          this.house_names[1] = "双床房";
          this.showHousePrice[1] = false;
        }
      }
    },
    addProductHouse() {
      let obj = {
        id: null,
        house_name: "",
        house_type: 1,
        price: "",
        vip_price: "",
        group_price: "",
        group_num: ""
      };

      this.form.product_house.push(obj);
    },
    delProductHouse(idx) {
      this.form.product_house.splice(idx, 1);
    },
    addRecommend() {
      let obj = {
        id: null,
        product_id: null,
        title: "",
        price: "",
        origin_price: "",
        shop_id: null,
        introduce: ""
      };
      if (this.form.type == 2) {
        obj.shop_id = 0;
      }
      this.form.product_recommend.push(obj);
    },
    delRecommend(idx) {
      this.form.product_recommend.splice(idx, 1);
    },
    resetForm(type, id) {
      (this.form = {
        id: id,
        shop_id: 0,
        title: "",
        cover: "",
        images: [],
        price: "",
        vip_price: "",
        kid_price: "",
        reserve: "",
        group_price: "",
        group_num: "",
        first_destination: "",
        second_destination: "",
        third_destination: "",
        sell: "0",
        novel: "",
        price_include: "",
        price_not_include: "",
        stock: "",
        package_name: "",
        description: "",
        instructions: "",
        return_modify: "",
        type: type,
        inspect_status: "1",
        status: "1",
        special_offer: "1",
        new_product: "1",
        weight: "1",
        expired: "",
        product_house: [null, null],
        product_category: [
          {
            id: null,
            parent_id: null,
            parent_parent_id: null,

            pivot: {
              product_id: null,
              product_category_id: null
            }
          }
        ],
        product_package: [
          {
            id: null,
            product_id: null,
            shop_id: null,
            title: "",
            live_time: "1",
            introduce: ""
          }
        ],
        product_recommend: [
          // {
          //   id: "",
          //   product_id: "",
          //   title: "",
          //   price: "",
          //   origin_price: "",
          //   shop_id: "",
          //   introduce: ""
          // }
        ]
      }),
          (this.btnLoading = false);
    },
    getFatherCategoryList(type, index, level, all = true, update = false) {
      var parent_id;
      if (level == 2) {
        if (type == 1) {
          if (all) {
            this.form.product_category[index].parent_id = null;
            this.form.product_category[index].id = null;
            this.form.product_category[index].name = "";
          }
          parent_id = this.form.product_category[index].parent_parent_id;
        } else {
          if (all) {
            this.form.second_destination = "";
            this.form.third_destination = "";
          }
          parent_id = this.form.first_destination;
        }
      } else if (level == 3) {
        if (type == 1) {
          if (!update) {
            this.form.product_category[index].id = null;
            this.form.product_category[index].name = "";
          }
          parent_id = this.form.product_category[index].parent_id;
        } else {
          if (!update) {
            this.form.third_destination = "";
          }
          parent_id = this.form.second_destination;
        }
      }
      if (level != 1) {
        request({
          url: "/api/backend/productCategory",
          method: "get",
          params: {
            level: level,
            page: 1,
            limit: 9999,
            type: type,
            parent_id: parent_id
          }
        }).then(response => {
          if (level == 2) {
            if (type == 1) {
              this.secondList[index] = response.data.data;
            } else {
              this.secondDestinationList = response.data.data;
            }
          } else if (level == 3) {
            if (type == 1) {
              this.thirdList[index] = response.data.data;
            } else {
              this.thirdDestinationList = response.data.data;
            }
          }
          this.$forceUpdate();
          this.loading = false;
        });
      } else {
        request({
          url: "/api/backend/productCategory",
          method: "get",
          params: {level: level, page: 1, limit: 9999, type: type}
        }).then(response => {
          type == 1
              ? (this.firstList = response.data.data)
              : (this.firstDestinationList = response.data.data);
          console.log(this.firstList)
        });
      }
    },
    reset() {
      if (localStorage.getItem('product')) {
        localStorage.removeItem('product')
        localStorage.removeItem('secondList')
        localStorage.removeItem('thirdList')
        localStorage.removeItem('secondDestinationList')
        localStorage.removeItem('thirdDestinationList')
        localStorage.removeItem('includeForm')

        this.resetForm(1, null)
        this.form.instructions = `<ul><li>入住有效期：<span style="color: #ed6464;"><strong>即日起至2020.12.30（10.1-10.6不适用）</strong></span>；</li><li>此套餐产品每日限量预约，需至少提前5天预约，预约情况须以酒店入住率为准；</li><li>所有订购均需<span style="color: #ed6464;"><strong>二次确认</strong></span>，预定完成后，我方平台会在18个工作小时内（工作日9:00-18:00）确认是否预定成功，最终以短信或客服通知为准。如预约失败，建议更改出行日期或者申请退款，详情参考退改说明。</li><li>本产品无需出团确认书，预定成功后即可出行。</li><li>酒店入住时间：下午15:00后，</li></ul><p style="padding-left: 30px;">&nbsp; 离店时间：中午12:00前；</p><ul><li>酒店入住方式：预订人持有效身份证件及酒店确认单号，于酒店前台办理入住。</li></ul><p>&nbsp;</p><p><strong>【费用说明】</strong></p><ul><li>产品价格已包含税费；</li><li>费用包含套餐内容中所列的成人及儿童限数；超出部分需另付费，具体可咨询客服；</li><li>加床政策及具体金额，可咨询客服；</li><li>产品中的部分餐食、活动项目，需提前与酒店预约，具体政策，可与客服咨询。</li></ul><p>&nbsp;</p><p>&nbsp;</p><p><strong>【开票说明】</strong></p><p style="padding-left: 30px;">我方平台为订单开具增值税电子普通发票，预定人需于入住完成后的三个月内申请，逾期恕不办理。</p>`
        this.form.return_modify = `<ul><li>订单付款成功后，未预约的套餐可以免费退；已预约成功的套餐，恕不接受任何退订及更改。</li><li>如因自身证件或身体健康状况等个人原因，导致订单无法出行或产生损失，责任自负。</li></ul><p>&nbsp;</p><p><strong>【如果申请退款】</strong></p><ul><li>未预约日期，我的&gt;全部订单&gt;申请售后&gt;申请退款；</li><li>已经预约日期/或者二次确认失败，请联系客服，或者添加客服微信进行处理。</li><li>客服微信号：dxwl_emma</li></ul>`
        this.includeForm = [
          {
            priceInc: ''
          }
        ]

        this.$notify({
          title: "成功",
          message: "清除成功",
          type: "success",
          duration: 2000
        });

        console.log('清除缓存')
      }
    },
    saveCacheData() {
      localStorage.setItem('product', JSON.stringify(this.form));
      localStorage.setItem('secondList', JSON.stringify(this.secondList));
      localStorage.setItem('thirdList', JSON.stringify(this.thirdList));
      localStorage.setItem('secondDestinationList', JSON.stringify(this.secondDestinationList));
      localStorage.setItem('thirdDestinationList', JSON.stringify(this.thirdDestinationList));
      localStorage.setItem('includeForm', JSON.stringify(this.includeForm));

      this.$notify({
        title: "成功",
        message: "保存成功",
        type: "success",
        duration: 2000
      });

      console.log('保存缓存')
    },
    showCacheData() {
      if (localStorage.getItem('product')) {
        console.log('显示缓存')

        this.form = JSON.parse(localStorage.getItem('product'));
        this.secondList = JSON.parse(localStorage.getItem('secondList'));
        this.thirdList = JSON.parse(localStorage.getItem('thirdList'));
        this.secondDestinationList = JSON.parse(localStorage.getItem('secondDestinationList'));
        this.thirdDestinationList = JSON.parse(localStorage.getItem('thirdDestinationList'));
        this.includeForm = JSON.parse(localStorage.getItem('includeForm'));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.app-container {
  .el-tag + .el-tag {
    margin-left: 10px;
  }

  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
}
</style>


